/**
 * The list of the UserWay widget triggers, like “LST" or “main" icons on the page
 */
export enum Trigger {
  Lst = 'lst',
  Main = 'main',
}
